import camelize from 'camelize'

class AloObject {
  constructor (rawObject) {
    rawObject = camelize(rawObject)

    Object.keys(rawObject).forEach(key => {
      this[key] = rawObject[key]
    })
  }
}

export default AloObject
